import React, { useState, useEffect } from 'react';
import { withStyles } from '@mui/styles';
import { WithStyles, StyleRules, ClassNameMap } from '@mui/material/styles/withStyles';
import { Theme } from '@mui/material/styles';
import {TextField, Button, Paper, Grid, Typography } from "@mui/material";
import * as request from 'superagent';
import AppView from '~common/components/app-view/index';
import LoadingView from '~common/components/loading-view';
import ErrorView from '~common/components/error-view';

const styles = (theme: Theme): StyleRules => ({
  container: {
    display: "flex",
    justifyContent: "center",
    marginTop: 100
  },
  paper: {
    width: 800,
    padding: 30,
    backgroundColor: "white",
  },
  textField: {
    width: 350
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
  match: any;
}

const ForceUserPasswordReset: React.FC<Props & WithStyles<keyof typeof styles>> = (props) => {
  const { classes }: { classes: ClassNameMap } = props;
  const [status, setStatus] = useState("loading");
  const [usersUpdated, setUsersUpdated] = useState(0)
  const [error, setError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(true)

  let errorView;
  if (error) {
    errorView = <ErrorView classes={{}} error={error}  />;
  }

  const handleChange = (e:any) => {
    if (e.target.value === "force password reset") {
      setButtonDisabled(false)
    } else {
      if (!buttonDisabled) {
        setButtonDisabled(true)
      }
    }
  }

  const handleForcePasswordClick = () => {
    fetch("/api/portal-users/password-reset-all",
      {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          method: "POST"
      })
      .then(function(res){ 
        return res.json()
      })
      .then(data => {
        setUsersUpdated(data.userUpdateCount)
      })
      .catch(function(res){ 
        setError("Failed to update user login")
      })
  }

    return (
      <AppView history={props.history}>
        <div>
            <Typography style={{ textAlign: "left" }} variant="h6">
            Force ALL User Password Reset
            </Typography>
          </div>
        <div className={classes.container}>
          
          <Paper className={classes.paper}>
            <Grid container spacing={10}>
                <Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography style={{ textAlign: "center" }} variant="subtitle1">
                    By clicking the button below, you will force <b>ALL</b> users that do not login using SAML to reset their password.  To continue with force password change, please type <b><i>force password reset</i></b> in the box below.
                  </Typography>
                </Grid>
                <Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div style={{ textAlign: "center" }} >
                    <TextField 
                      onChange={handleChange}
                      autoFocus 
                      className={classes.textField}
                    />
                  </div>
                  <div style={{marginTop: 10, textAlign: "center" }} >
                    <Button 
                      style={{width: 150}}
                      disabled={buttonDisabled}
                      variant="contained"
                      color="secondary"
                      onClick={handleForcePasswordClick}
                    >Submit</Button>
                    {usersUpdated > 0 && <div>
                      <Typography style={{marginTop: 20, textAlign: "center" }} variant="subtitle1">
                        Users Updated: {usersUpdated}
                      </Typography>
                      </div>}
                    {errorMessage && <div>
                      <Typography style={{color: 'red', marginTop: 20, textAlign: "center" }} variant="subtitle1">
                        {errorMessage}
                      </Typography>
                      </div>}
                  </div>
                </Grid>
              </Grid>
          </Paper>
        </div>
      </AppView>
    );
    
  
};

export default withStyles(styles)(ForceUserPasswordReset);